/**
 * Mapeamentos centralizados value (API/enum) → label PT-BR para UI.
 * Persistência continua usando as keys/values internos.
 */

export const TEMPLATE_TYPE_OPTIONS = [
  { value: 'prescription', label: 'Receita' },
  { value: 'certificate', label: 'Atestado' },
  { value: 'exam_request', label: 'Pedido de Exame' },
  { value: 'other', label: 'Outro' },
] as const;

export type TemplateTypeValue = (typeof TEMPLATE_TYPE_OPTIONS)[number]['value'];

export const TEMPLATE_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  TEMPLATE_TYPE_OPTIONS.map((o) => [o.value, o.label]),
);

/** Normaliza tipos legados/uppercase vindos da API para o value interno. */
export function normalizeTemplateType(raw: string | null | undefined): TemplateTypeValue {
  if (!raw) return 'prescription';
  const key = String(raw).trim();
  const upperMap: Record<string, TemplateTypeValue> = {
    prescription: 'prescription',
    PRESCRIPTION: 'prescription',
    RECIPE: 'prescription',
    recipe: 'prescription',
    certificate: 'certificate',
    CERTIFICATE: 'certificate',
    exam_request: 'exam_request',
    EXAM_REQUEST: 'exam_request',
    other: 'other',
    OTHER: 'other',
  };
  return upperMap[key] ?? upperMap[key.toLowerCase()] ?? 'other';
}

export function getTemplateTypeLabel(value: string | null | undefined): string {
  const normalized = normalizeTemplateType(value);
  return TEMPLATE_TYPE_LABELS[normalized] ?? 'Outro';
}

export const AVAILABILITY_TYPE_OPTIONS = [
  { value: 'TELEMEDICINE', label: 'Telemedicina' },
  { value: 'HOME', label: 'Domiciliar' },
  { value: 'CLINIC', label: 'Consultório' },
] as const;

export type AvailabilityTypeValue = (typeof AVAILABILITY_TYPE_OPTIONS)[number]['value'];

export const AVAILABILITY_TYPE_LABELS: Record<string, string> = Object.fromEntries(
  AVAILABILITY_TYPE_OPTIONS.map((o) => [o.value, o.label]),
);

export function normalizeAvailabilityType(
  raw: string | null | undefined,
): AvailabilityTypeValue {
  if (!raw) return 'TELEMEDICINE';
  const key = String(raw).trim().toUpperCase();
  if (key === 'TELEMEDICINE' || key === 'HOME' || key === 'CLINIC') {
    return key;
  }
  // Aliases eventuais
  if (key === 'VIDEO' || key === 'TELEMEDICINA') return 'TELEMEDICINE';
  if (key === 'DOMICILIAR' || key === 'HOME_CARE') return 'HOME';
  if (key === 'CONSULTORIO' || key === 'OFFICE') return 'CLINIC';
  return 'TELEMEDICINE';
}

export function getAvailabilityTypeLabel(value: string | null | undefined): string {
  const normalized = normalizeAvailabilityType(value);
  return AVAILABILITY_TYPE_LABELS[normalized] ?? normalized;
}
